import React from 'react';
import './AnimateBG.scss';

const AnimateBG = ({ children }) => {
  return (
    <div className="animated-background-wrapper">
      <div className="slice">
        <div className="bg"></div>
        <div className="bg bg2"></div>
        <div className="bg bg3"></div>
      </div>
      {children}
    </div>
  );
};

export default AnimateBG;
